var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSzkolaPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "szkola"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "184.43 65.67 100.78 52.05 63.83 6.18 186.82 44.38 221.45 71.69 200.53 68.29",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "193.78 100.25 176.64 100.43 152.01 102.04 152.01 70.08",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "217.34 71.33 217.34 97.04 206.45 97.57",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "203.77 71.69 198.42 65.62 191.64 70.62 178.07 70.62",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.24,
    y1: 96.15,
    x2: 203.95,
    y2: 95.79,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.21,
    y1: 98.29,
    x2: 205.92,
    y2: 97.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.17,
    y1: 100.43,
    x2: 207.88,
    y2: 100.07,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "114.17 54.55 130.95 66.87 155.94 69.19 140.76 58.48",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "98.81 53.13 34.55 60.98 63.83 6.18",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.56,
    y1: 96.86,
    x2: 112.56,
    y2: 55.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "35.62 61.16 35.62 97.57 90.6 103.46",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.64,
    y1: 70.62,
    x2: 191.64,
    y2: 99.54,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.81,
    y1: 69.73,
    x2: 201.81,
    y2: 94.36,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.05,
    y1: 66.87,
    x2: 130.05,
    y2: 98.29,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.95,
    y1: 98.47,
    x2: 121.31,
    y2: 98.47,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.28,
    y1: 101.14,
    x2: 118.63,
    y2: 101.14,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.6,
    y1: 103.82,
    x2: 115.95,
    y2: 103.82,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.31,
    y: 72.76,
    width: 7.68,
    height: 24.28,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.62,
    y: 72.94,
    width: 5.36,
    height: 14.64,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.14 70.08 162.54 69.19 162.54 87.04 174.14 87.04 174.14 70.08",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.78,
    y1: 52.05,
    x2: 100.78,
    y2: 99.72,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.53 74.55 206.63 75.08 206.63 88.11 202.53 88.11 202.53 74.55",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.45 87.76 211.45 76.15 213.95 76.51 213.95 87.93 211.45 87.76",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.53,
    y1: 99.72,
    x2: 177.53,
    y2: 73.12,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.86 85.79 81.86 62.05 73.47 62.59 73.47 85.79 81.86 85.79",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.29 84.54 63.29 64.37 56.51 65.26 56.51 84.72 63.29 84.54",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.76 65.8 47.76 85.26 42.05 85.43 42.05 66.33 47.76 65.8",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.42,
    y1: 65.62,
    x2: 184.94,
    y2: 65.62,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzkolaPop);
export default __webpack_public_path__ + "static/media/szkola_pop.1143dd66c00822ce845f46d766daa4e5.svg";
export { ForwardRef as ReactComponent };